import React from 'react';
import { 
  LineChart, Line, PieChart, Pie, Cell, 
  XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer 
} from 'recharts';

export default function ProjectsDashboard() {
  // Mock Data
  const tasksOverTime = [
    { name: 'Jan 19', projects: 550, complete: 250 },
    { name: 'Jan 20', projects: 650, complete: 300 },
    { name: 'May 20', projects: 600, complete: 280 },
    { name: 'Jan 21', projects: 800, complete: 400 },
    { name: 'Dec 21', projects: 700, complete: 350 },
    { name: 'Jan 22', projects: 950, complete: 500 },
    { name: 'Dec 22', projects: 850, complete: 420 },
    { name: 'Jan 23', projects: 1100, complete: 600 },
    { name: 'May 23', projects: 1000, complete: 520 },
    { name: 'Jul 23', projects: 1200, complete: 750 },
    { name: 'Aug 23', projects: 1250, complete: 780 },
  ];

  const statusData = [
    { name: 'At Risk', value: 16, color: '#6B46C1' },
    { name: 'On Track', value: 13, color: '#34D399' },
    { name: 'Delayed', value: 8, color: '#FBBF24' },
    { name: 'Total', value: 1, color: '#EF4444' },
  ];

  const recentActivity = [
    { title: 'New Project added', desc: 'New Time', date: 'May 29, 2020', icon: 'M', color: '#10B981', bg: '#D1FAE5' },
    { title: 'Project launched', desc: 'Project3Server..', date: 'May 28, 2020', icon: 'P', color: '#6B46C1', bg: '#EDE9FE' },
    { title: 'Campaign launched', desc: 'Corp-Reoversd..', date: 'May 25, 2020', icon: 'C', color: '#6B46C1', bg: '#EDE9FE' },
    { title: 'Project activated', desc: 'Altmnlikate', date: 'May 25, 2020', icon: 'A', color: '#10B981', bg: '#D1FAE5' },
  ];

  const tasks = [
    { title: 'Emneze 220 campaign updatement', date: 'May 25, 2020', completed: true },
    { title: 'Approve tasks member verifications', date: '', completed: true },
    { title: 'Ingckso aerchise pricing', date: '', completed: true },
    { title: 'Preprive mending updat', date: '', completed: false },
  ];

  // Helper for rendering a small donut pie chart
  const renderDonut = (value, color) => {
    const data = [
      { name: 'Active', value: value, color: color },
      { name: 'Inactive', value: 100 - value, color: '#F3F4F6' }
    ];
    return (
      <div style={{ position: 'relative', width: '32px', height: '32px', flexShrink: 0 }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie data={data} innerRadius={10} outerRadius={16} dataKey="value" startAngle={90} endAngle={-270} stroke="none">
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </div>
    );
  };

  return (
    <div style={{ padding: '24px', backgroundColor: '#F9FAFB', minHeight: '100vh', fontFamily: 'Inter, sans-serif' }}>
      
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
        <h1 style={{ fontSize: '28px', fontWeight: 'bold', color: '#111827', margin: 0 }}>Overview</h1>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <div style={{ padding: '6px 12px', borderRadius: '8px', border: '1px solid #E5E7EB', backgroundColor: '#fff', fontSize: '13px', color: '#4B5563', display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
            All Entities <span style={{ fontSize: '10px' }}>▼</span>
          </div>
          <div style={{ padding: '6px 12px', borderRadius: '8px', border: '1px solid #E5E7EB', backgroundColor: '#fff', fontSize: '13px', color: '#4B5563', display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
            May - July 1, 2023 <span style={{ fontSize: '10px' }}>▼</span>
          </div>
        </div>
      </div>

      {/* KPI Cards */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px', marginBottom: '20px' }}>
        {/* Card 1: Active Projects */}
        <div style={{ backgroundColor: '#fff', padding: '16px', borderRadius: '12px', border: '1px solid #E5E7EB', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <div style={{ fontSize: '14px', color: '#111827', fontWeight: '600', marginBottom: '12px', whiteSpace: 'nowrap' }}>Active Projects</div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ minWidth: 0 }}>
              <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#111827', lineHeight: 1, marginBottom: '6px' }}>2</div>
              <div style={{ fontSize: '11px', color: '#6B7280', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>+ Active Projects</div>
            </div>
            <div style={{ width: '36px', height: '36px', backgroundColor: '#EDE9FE', color: '#6B46C1', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px', flexShrink: 0 }}>
              <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
            </div>
          </div>
        </div>

        {/* Card 2: Completed Tasks */}
        <div style={{ backgroundColor: '#fff', padding: '16px', borderRadius: '12px', border: '1px solid #E5E7EB', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <div style={{ fontSize: '14px', color: '#111827', fontWeight: '600', marginBottom: '12px', whiteSpace: 'nowrap' }}>Completed Tasks</div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ minWidth: 0 }}>
              <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#111827', lineHeight: 1, marginBottom: '6px' }}>25</div>
              <div style={{ fontSize: '11px', color: '#059669', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>+ 21,938 Projects</div>
            </div>
            <div style={{ width: '36px', height: '36px', backgroundColor: '#EDE9FE', color: '#6B46C1', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px', flexShrink: 0 }}>
              <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
            </div>
          </div>
        </div>

        {/* Card 3: Overall Progress % */}
        <div style={{ backgroundColor: '#fff', padding: '16px', borderRadius: '12px', border: '1px solid #E5E7EB', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <div style={{ fontSize: '14px', color: '#111827', fontWeight: '600', marginBottom: '12px', whiteSpace: 'nowrap' }}>Overall Progress %</div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ minWidth: 0 }}>
              <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#111827', lineHeight: 1, marginBottom: '6px' }}>88.7%</div>
              <div style={{ fontSize: '11px', color: '#059669', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>+ 51.2% overall</div>
            </div>
            {renderDonut(88.7, '#10B981')}
          </div>
        </div>

        {/* Card 4: Resource Utilization */}
        <div style={{ backgroundColor: '#fff', padding: '16px', borderRadius: '12px', border: '1px solid #E5E7EB', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <div style={{ fontSize: '14px', color: '#111827', fontWeight: '600', marginBottom: '12px', whiteSpace: 'nowrap' }}>Resource Utilization</div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ minWidth: 0 }}>
              <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#111827', lineHeight: 1, marginBottom: '6px' }}>92%</div>
              <div style={{ fontSize: '11px', color: '#059669', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>+ 38% of avg</div>
            </div>
            <div style={{ width: '36px', height: '36px', backgroundColor: '#D1FAE5', color: '#059669', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px', flexShrink: 0 }}>
              <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
            </div>
          </div>
        </div>
      </div>

      {/* Middle Row */}
      <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '16px', marginBottom: '20px' }}>
        {/* Chart */}
        <div style={{ backgroundColor: '#fff', padding: '20px', borderRadius: '12px', border: '1px solid #E5E7EB' }}>
          <div style={{ fontSize: '15px', fontWeight: '600', color: '#111827', marginBottom: '20px', display: 'flex', justifyContent: 'space-between' }}>
            Project Tasks Completed Over Time
            <div style={{ display: 'flex', gap: '16px', fontSize: '12px', fontWeight: '500' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#6B46C1' }}>
                <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#6B46C1' }}></div>
                Projects
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#9CA3AF' }}>
                <div style={{ width: '8px', height: '8px', borderRadius: '50%', border: '2px solid #9CA3AF', backgroundColor: '#fff' }}></div>
                New Complete
              </div>
            </div>
          </div>
          <div style={{ height: '220px' }}>
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={tasksOverTime}>
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E5E7EB" />
                <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{ fontSize: 11, fill: '#6B7280' }} dy={10} />
                <YAxis axisLine={false} tickLine={false} tick={{ fontSize: 11, fill: '#6B7280' }} dx={-10} domain={[0, 1500]} ticks={[0, 500, 1000, 1500]} />
                <Tooltip contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }} />
                <Line type="monotone" dataKey="projects" stroke="#6B46C1" strokeWidth={2} dot={{ r: 4, fill: '#fff', stroke: '#6B46C1', strokeWidth: 2 }} activeDot={{ r: 6 }} />
                <Line type="monotone" dataKey="complete" stroke="#9CA3AF" strokeWidth={2} dot={{ r: 4, fill: '#fff', stroke: '#9CA3AF', strokeWidth: 2 }} activeDot={{ r: 6 }} />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Projects by Status */}
        <div style={{ backgroundColor: '#fff', padding: '20px', borderRadius: '12px', border: '1px solid #E5E7EB', display: 'flex', flexDirection: 'column' }}>
          <div style={{ fontSize: '15px', fontWeight: '600', color: '#111827', marginBottom: '20px' }}>Projects by Status</div>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '20px', flex: 1 }}>
            
            <div style={{ position: 'relative', width: '140px', height: '140px', flexShrink: 0 }}>
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie data={statusData} innerRadius={45} outerRadius={65} dataKey="value" stroke="#fff" strokeWidth={2}>
                    {statusData.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={entry.color} />
                    ))}
                  </Pie>
                </PieChart>
              </ResponsiveContainer>
              <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#111827', lineHeight: 1 }}>2,431</div>
                <div style={{ fontSize: '11px', color: '#6B7280' }}>Projects</div>
              </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {statusData.map((stat, idx) => (
                <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '12px' }}>
                  <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: stat.color }}></div>
                  <span style={{ color: '#111827', width: '60px' }}>{stat.name}</span>
                  <span style={{ color: '#4B5563', fontWeight: '500' }}>{stat.value}</span>
                </div>
              ))}
            </div>

          </div>
        </div>
      </div>

      {/* Bottom Row */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
        {/* Recent Activity */}
        <div style={{ backgroundColor: '#fff', padding: '20px', borderRadius: '12px', border: '1px solid #E5E7EB', display: 'flex', flexDirection: 'column' }}>
          <div style={{ fontSize: '15px', fontWeight: '600', color: '#111827', marginBottom: '20px' }}>Recent Activity</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', flex: 1 }}>
            {recentActivity.map((act, index) => (
              <div key={index} style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                <div style={{ width: '32px', height: '32px', borderRadius: '8px', backgroundColor: act.bg, color: act.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '14px', fontWeight: 'bold', flexShrink: 0 }}>
                  {act.icon}
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: '13px', fontWeight: '600', color: '#111827', marginBottom: '4px' }}>{act.title}</div>
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: '13px', color: '#4B5563' }}>{act.desc}</div>
                </div>
                <div style={{ fontSize: '12px', color: '#9CA3AF', whiteSpace: 'nowrap' }}>
                  {act.date}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Tasks */}
        <div style={{ backgroundColor: '#fff', padding: '20px', borderRadius: '12px', border: '1px solid #E5E7EB', display: 'flex', flexDirection: 'column' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
            <div style={{ fontSize: '15px', fontWeight: '600', color: '#111827' }}>Tasks</div>
            <div style={{ fontSize: '13px', color: '#4B5563' }}>All of 8 Completed</div>
            <div style={{ fontSize: '13px', color: '#4B5563' }}>98%</div>
          </div>
          
          <div style={{ width: '100%', height: '6px', backgroundColor: '#F3F4F6', borderRadius: '3px', marginBottom: '20px', position: 'relative' }}>
            <div style={{ position: 'absolute', top: 0, left: 0, height: '100%', width: `98%`, backgroundColor: '#6B46C1', borderRadius: '3px' }}></div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', flex: 1 }}>
            {tasks.map((task, index) => (
              <div key={index} style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                <div style={{ width: '16px', height: '16px', borderRadius: '50%', border: task.completed ? 'none' : '2px solid #D1D5DB', backgroundColor: task.completed ? '#6B46C1' : 'transparent', display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '2px', flexShrink: 0 }}>
                  {task.completed && <svg width="10" height="10" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"></polyline></svg>}
                </div>
                <div>
                  <div style={{ fontSize: '13px', fontWeight: '500', color: task.completed ? '#111827' : '#4B5563', textDecoration: task.completed ? 'none' : 'none' }}>{task.title}</div>
                  {task.date && <div style={{ fontSize: '11px', color: '#9CA3AF', marginTop: '4px' }}>{task.date}</div>}
                </div>
              </div>
            ))}
          </div>
          <div style={{ marginTop: '16px' }}>
            <button style={{ color: '#6B46C1', background: 'none', border: 'none', fontSize: '13px', cursor: 'pointer', padding: 0 }}>
              View all tasks
            </button>
          </div>
        </div>
      </div>

    </div>
  );
}
